howspace.components.collapse = (() => {
    'use strict';

    const resetCssProperties = {
        'display' : '',
        'width' : '',
        'height' : '',
        'margin-top' : '',
        'margin-bottom' : '',
        'padding-top' : '',
        'padding-bottom' : '',
        'overflow' : ''
    };

    const getTargetElems = (elem) => {
        if (elem instanceof jQuery) {
            elem = elem[0];
        }
        const targetElems = [];
        elem.getAttribute('aria-controls').split(' ').forEach(id => {
            const targetElem = $('#' + id);
            if (targetElem.length > 0) {
                targetElems.push(targetElem);
            }
        });
        return targetElems;
    };

    const showCollapse = (elem, animate = true) => {
        if (elem instanceof jQuery) {
            elem = elem[0];
        }
        getTargetElems(elem).forEach(targetElem => {
            if (targetElem.is('.collapsed, .collapsing')) {
                if (animate === false) {
                    targetElem.css('--collapse-animation-duration', '0');
                }
                toggleCollapse(elem, targetElem);
                if (animate === false) {
                    setTimeout(() => {
                        targetElem.css('--collapse-animation-duration', '');
                    }, 100);
                }
            }
        });
    };

    const hideCollapse = (elem, animate = true) => {
        if (elem instanceof jQuery) {
            elem = elem[0];
        }
        getTargetElems(elem).forEach(targetElem => {
            if (targetElem.is('.expanded, .expanding')) {
                if (animate === false) {
                    targetElem.css('--collapse-animation-duration', '0');
                }
                toggleCollapse(elem, targetElem);
                if (animate === false) {
                    setTimeout(() => {
                        targetElem.css('--collapse-animation-duration', '');
                    }, 100);
                }
            }
        });
    };

    const toggleCollapse = (collapse, targetElem) => {
        if (collapse instanceof jQuery) {
            collapse = collapse[0];
        }

        if (targetElem.is('.expanded, .expanding')) {
            collapse.setAttribute('aria-expanded', 'false');
            close(targetElem);
        } else {
            collapse.setAttribute('aria-expanded', 'true');
            open(targetElem);
        }
    };

    const close = (targetElem) => {
        if (targetElem.length === 0) {
            return;
        }
        const animationDuration = howspace.getAnimationDuration(targetElem, '--collapse-animation-duration');

        targetElem.removeClass('expanded').addClass('collapsing');
        howspace.dispatchEvent(targetElem, howspace.components.collapse.COLLAPSING);
        howspace.animate(targetElem, 'slideUp', animationDuration, () => {
            if (targetElem.data('skip-data-when-collapsed')) {
                targetElem.dataAndAttr('skip-from-real-form', true);
            }
            targetElem.removeClass('collapsing expanding d-none').addClass('collapsed').css(resetCssProperties);
            howspace.dispatchEvent(targetElem, howspace.components.collapse.COLLAPSED);
        });
    }

    const open = (targetElem) => {
        if (targetElem.length === 0) {
            return;
        }
        const animationDuration = howspace.getAnimationDuration(targetElem, '--collapse-animation-duration');

        targetElem.removeClass('collapsed');
        requestAnimationFrame(() => {
            howspace.components.autosize.update(targetElem);
            howspace.components.textEditor.repaint(targetElem);
            targetElem.addClass('expanding');
            howspace.dispatchEvent(targetElem, howspace.components.collapse.EXPANDING);
        });
        howspace.animate(targetElem, 'slideDown', animationDuration, () => {
            if (targetElem.data('skip-data-when-collapsed')) {
                targetElem.dataAndAttr('skip-from-real-form', false);
            }
            targetElem.removeClass('expanding collapsing').addClass('expanded').css(resetCssProperties);
            howspace.dispatchEvent(targetElem, howspace.components.collapse.EXPANDED);
        });
    }

    const toggleCollapses = (elem) => {
        getTargetElems(elem).forEach(targetElem => {
            toggleCollapse(elem, targetElem);
        });
    };

    const handleChange = (e) => {
        toggleCollapses($(e.currentTarget));
    };

    const handleRadioChecked = radio => {
        if (radio.dataset.reverseControl === 'true') {
            if (radio.getAttribute('aria-expanded') === 'true') {
                // Checked radio reverse controls a collapse that is expanded, time to collapse.
                toggleCollapses($(radio));
            }
        } else if (radio.getAttribute('aria-expanded') === 'false') {
            // Checked radio controls a collapse that is collapsed, time to expand.
            toggleCollapses($(radio));
        }
    };

    const handleRadioUnchecked = radio => {
        if (radio.dataset.reverseControl === 'true') {
            if (radio.getAttribute('aria-expanded') === 'false') {
                // Unchecked radio reverse controls a collapse that is collapsed, time to expand.
                toggleCollapses($(radio));
            }
        } else if (radio.getAttribute('aria-expanded') === 'true') {
            // Unchecked radio controls a collapse that is expanded, time to collapse.
            toggleCollapses($(radio));
        }
    };

    const handleRadioChange = (e) => {
        const radio = e.target;
        const parent = radio.closest('.howspace-form-radio-button').parentNode;
        parent.querySelectorAll('input[type="radio"]').forEach(loopRadio => {
            if (!loopRadio.hasAttribute('aria-controls')) {
                // The looped radio does not control a collapse, skip to next one.
                return;
            }

            if (radio === loopRadio) {
                // The looped radio button was checked.
                handleRadioChecked(loopRadio);
            } else {
                // Some other radio was checked.
                handleRadioUnchecked(loopRadio);
            }
        });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // Enter or Space keypress.
            // https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
            e.preventDefault();
            toggleCollapses($(e.target));
        }
    };

    return {
        COLLAPSING : 'howspace-collapse-collapsing',
        COLLAPSED : 'howspace-collapse-collapsed',
        EXPANDING : 'howspace-collapse-expanding',
        EXPANDED : 'howspace-collapse-expanded',
        init : (elem) => {
            // Checkboxes.
            elem.findIncludingSelf('input[type="checkbox"][aria-controls]:not(.howspace-collapse-initialized)').each(function() {
                const input = $(this);
                input.addClass('howspace-collapse-initialized');
                input.on('change', handleChange);
            });

            // Radio buttons (slightly different case than others, find all parents that contain radio buttons that have control).
            elem.findIncludingSelf('*:not(.howspace-collapse-initialized):has(> .howspace-form-radio-button > input[type="radio"][aria-controls])').each(function() {
                const parent = $(this);
                parent.addClass('howspace-collapse-initialized');
                parent.find('input[type="radio"]').on('change', handleRadioChange);
            });

            // Buttons, role="button" and tabindex="0" elements.
            const btnSelectors = [
                '.btn[aria-controls]:not(.howspace-collapse-initialized)',
                '[role="button"][aria-controls]:not(.howspace-collapse-initialized)',
                '[tabindex="0"][aria-controls]:not(.howspace-collapse-initialized)'
            ];
            elem.findIncludingSelf(btnSelectors.join(', ')).each(function() {
                const btn = $(this);
                btn.addClass('howspace-collapse-initialized');
                btn.on('click', handleChange);
                btn.on('keypress', handleKeyPress);
            });
        },
        destroy : (elem) => {
            // Checkboxes.
            elem.findIncludingSelf('input[type="checkbox"][aria-controls].howspace-collapse-initialized').each(function() {
                const input = $(this);
                input.removeClass('howspace-collapse-initialized');
                input.off('change', handleChange);
            });

            // Radio buttons.
            elem.findIncludingSelf('input[type="radio"][aria-controls].howspace-collapse-initialized').each(function() {
                const parent = $(this);
                parent.removeClass('howspace-collapse-initialized');
                parent.find('input[type="radio"]').off('change', handleRadioChange);
            });

            // Buttons and role="button" elements.
            elem.findIncludingSelf('.btn[aria-controls].howspace-collapse-initialized, button[aria-controls].howspace-collapse-initialized, [role="button"][aria-controls].howspace-collapse-initialized').each(function() {
                const btn = $(this);
                btn.removeClass('howspace-collapse-initialized');
                btn.off('click', handleChange);
                btn.off('keypress', handleKeyPress);
            });
        },
        toggle : toggleCollapses,
        expand : showCollapse,
        collapse : hideCollapse,
        close: close,
        open: open,
    };

})();
